import React from 'react';
import { graphql } from 'gatsby';
import { get } from 'lodash';
import LayoutNoData from '../../components/Layout/LayoutNoData';

import { SEO, SEO_PAGE_TYPES } from '../../components/SEO/SEO';
import Paragraphs from '../../components/Paragraphs/Paragraphs';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Wrapper from './Landing.styles';

class Landing extends React.Component {
  render() {
    const page = get(this.props, 'data.allContentfulPageLandingPage.edges[0].node');
    const { edges: partnerEdges } = get(this.props, 'data.allContentfulPagePartner');
    const { edges: peopleEdges } = get(this.props, 'data.allContentfulPagePerson');
    const { edges: moneyBuyEdges } = get(this.props, 'data.allContentfulCart');
    const descData = get(this.props, 'data.allContentfulDescriptor');
    const paragraphs = get(
      this.props,
      'data.allContentfulPageLandingPage.edges[0].node.paragraphs'
    );
    const articles = get(this.props, 'data.featArticles.edges');
    const header = get(this.props, 'data.allContentfulHeaderMenu.edges[0].node');

    const {
      title,
      cartId,
      parentPages,
      showBreadcrumb, backgroundColour
    } = page;

    const { theme, themeCustomisation } = get(this.props, 'pageContext');
    const landingPageCartId = cartId;

    return (
      <LayoutNoData
        menu={header}
        landingPageCartId={landingPageCartId}
        backgroundColour={backgroundColour}
      >

        <Wrapper data-test="landing" pageTheme={themeCustomisation}>

          {showBreadcrumb
            && (
              <Breadcrumb
                thisPageTitle={title}
                parentPages={parentPages}
                backgroundColour={backgroundColour}
              />
            )}

          {paragraphs && (
            <Paragraphs
              theme={theme}
              paragraphs={paragraphs}
              partners={partnerEdges}
              people={peopleEdges}
              articles={articles}
              moneyBuys={moneyBuyEdges}
              descriptors={descData}
            />
          )}
        </Wrapper>
      </LayoutNoData>
    );
  }
}

export const Head = props => (
  <SEO
    allData={props}
    pageType={SEO_PAGE_TYPES.LANDING}
  />
);

export default Landing;

export const pageQuery = graphql`
query getLanding($slug: String, $category: String, $partnerCategory: [String]) {
  allContentfulPageLandingPage(filter: {path: {eq: $slug}}) {
    edges {
      node {
        path
        title
        cartId
        excludeFromSearchEngineIndexing
        imageSeo {
          ...Picture
        }
        summary {
          summary
        }
        imageSeo {
          file {
            url
          }
        }
        removeDonateLink
        paragraphs {
          ...PartnerListParagraph
          ...PeopleListParagraph
          ...SingleMessageParagraph
          ...CardsParagraph
          ...DonateBanner
          ...FeaturedNewsParagraph
          ...IframeParagraph
          ...CtaSingleCard
          ...CtaMultiCard
          ...DescriptorParagraph
          ...BitesizeParagraph
          ...HTMLParagraph
          ...ImpactSlider
          ...MapParagraph
          ...WhatYourMoneyDoesCarousel
          ...RichtextCarousel
          ...HeroBanner
          ...DynamicGallery
          ...QuoteSlice
          ...StatsSlice
          ...EmailBanner
        }
        backgroundColour
        showBreadcrumb
        parentPages {
          ... on Node {
            ... on ContentfulPageLandingPage {
              title
              path
            }
              ... on ContentfulPageDefault {
              title
              path
            }
          }
        }
      }
    }
  }
  featArticles: allContentfulPageArticle(
    filter: {categories: {elemMatch: {title: {glob: $category}}}, type: {eq: "News Article"}, excludeFromFeatureArticles: {ne: "Yes"}}
    limit: 3
    sort: {displayDate: DESC}
  ) {
    edges {
      node {
        title
        categories {
          title
        }
        path
        type
        id
        displayDate(formatString: "D MMMM YYYY")
        image {
          ...Picture
        }
      }
    }
  }
  allContentfulPagePartner(
    sort: {weight: ASC}
    filter: {group: {title: {in: $partnerCategory}}}
  ) {
    edges {
      node {
        ...PartnerList
      }
    }
  }
  allContentfulPagePerson(filter: {type: {ne: null}}) {
    edges {
      node {
        ...PeopleList
      }
    }
  }
  allContentfulDescriptor(sort: {date: DESC}) {
    group(field: {category: SELECT}) {
      fieldValue
      totalCount
    }
    edges {
      node {
        ...Descriptor
      }
    }
  }
  allContentfulHeaderMenu(limit: 1, sort: {updatedAt: DESC}) {
        edges {
          node {
            menuName
            showSearch
            headerPageGroups {
              id
              primaryPageName
              primaryPageUrlIfExternal
              primaryPageSelector {
                ... on ContentfulPageDefault {
                  id
                  path
                  title
                }
                ... on ContentfulPageLandingPage {
                  id
                  path
                  title
                }
                ... on ContentfulPageFundraiserSignup2022 {
                  id
                  path
                  title
                }
              }
              column1PageLinks {
                id
                pageLevel
                pageName
                pageUrlIfExternal
                pageSelector {
                  ... on ContentfulPageDefault {
                    id
                    path
                    title
                  }
                  ... on ContentfulPageLandingPage {
                    id
                    path
                    title
                  }
                  ... on ContentfulPageFundraiserSignup2022 {
                    id
                    path
                    title
                  }
                }
              }
              column2PageLinks {
                id
                pageLevel
                pageName
                pageUrlIfExternal
                pageSelector {
                  ... on ContentfulPageDefault {
                    id
                    path
                    title
                  }
                  ... on ContentfulPageLandingPage {
                    id
                    path
                    title
                  }
                  ... on ContentfulPageFundraiserSignup2022 {
                    id
                    path
                    title
                  }
                }
              }
              column3PageLinks {
                id
                pageLevel
                pageName
                pageUrlIfExternal
                pageSelector {
                  ... on ContentfulPageDefault {
                    id
                    path
                    title
                  }
                  ... on ContentfulPageLandingPage {
                    id
                    path
                    title
                  }
                  ... on ContentfulPageFundraiserSignup2022 {
                    id
                    path
                    title
                  }
                }
              }
              column3PageCards {
                id
                pageName
                pageDescription
                primaryPageUrlIfExternal
                image {
                  title
                  url
                  id
                }
                pageSelector {
                  ... on ContentfulPageDefault {
                    id
                    path
                    title
                  }
                  ... on ContentfulPageLandingPage {
                    id
                    path
                    title
                  }
                  ... on ContentfulPageFundraiserSignup2022 {
                    id
                    path
                    title
                  }
                }
              }
            }
          }
        }
      }
  allContentfulCart {
    edges {
      node {
        cartId
        contentful_id
        singleGiving {
          moneybuys {
            description
            value
          }
        }
        regularGiving {
          moneybuys {
            description
            value
          }
        }
      }
    }
  }
}
`;
